<template>
    <div class="row">
        <FormGroupNew class="col-12"
                      :label="__('sale.delivery_note_info.ust_id')"
                      description="Bitte geben Sie die Ust-Id. für Ihr Geschäft an."
                      :error="value.errors.ust_id"
                      :warning="requiresAdditionalInfo && !localForm.ust_id"
                      required
        >
            <input type="text" class="form-control" placeholder="DE 123456789" v-model="localForm.ust_id">
        </FormGroupNew>
        <div class="col-md-6">
            <FormGroupNew label="Handelsregistergericht"
                          description="Falls Sie eine HRN für Ihr Geschäft haben, tragen Sie hier den Namen des verantwortlichen Gerichts ein."
                          :error="value.errors.trade_reg_court"
                          required
            >
                <input type="text"
                       class="form-control"
                       placeholder="Verantwortliches Gericht"
                       v-model="localForm.trade_reg_court">
            </FormGroupNew>
        </div>
        <div class="col-md-6">
            <FormGroupNew label="Handelsregisternummer"
                          description="Falls vorhanden, geben Sie hier die Handelsregisternummer für Ihr Geschäft ein."
                          :error="value.errors.trade_reg_num"
                          required
            >
                <input type="text"
                       class="form-control"
                       placeholder="HRB 12345"
                       v-model="localForm.trade_reg_num">
            </FormGroupNew>
        </div>
    </div>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew},

    props: {
        value: Object,
        requiresAdditionalInfo: Boolean
    },

    data() {
        return {
            localForm: this.value
        };
    },

    watch: {
        localForm: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
